import React, { useContext } from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { Formik } from "formik";
import { Modal } from "react-bootstrap";
import NotyfContext from "../../../../contexts/NotyfContext";
import AddWatchdogForm from "./AddWatchdogForm";
import { createWatchdog } from "../../../../redux/slices/watchdogs";

const AddWatchdogModal = ({
  openAddWatchdogModal,
  setOpenAddWatchdogModal,
  selectedSims,
  clearSelectedRows,
}) => {
  const handleClose = () => setOpenAddWatchdogModal(false);
  const dispatch = useDispatch();
  const notyf = useContext(NotyfContext);

  const initialValues = {
    actionType: "none",
    amount: "",
    service: "",
    enableSuspendInterval: false,
    suspendInterval: "",
    warning: "",
    warning1: "",
    warning2: "",
    unitType: "byte",
    watchdogInterval: "",
    notificationType: "none",
  };

  const validationSchema = Yup.object().shape({
    actionType: Yup.string().required("Required"),
    amount: Yup.number().min(0, "Amount must be positive").required("Required"),
    service: Yup.object().nullable(),
    enableSuspendInterval: Yup.boolean(),
    suspendInterval: Yup.string().when("enableSuspendInterval", {
      is: true,
      then: Yup.string().required("Required"),
      otherwise: Yup.string().nullable().notRequired(),
    }),
    warning: Yup.number("Must be a number").notRequired().nullable(),
    warning1: Yup.number("Must be a number").notRequired().nullable(),
    warning2: Yup.number("Must be a number").notRequired().nullable(),
    unitType: Yup.string().required("Required"),
    watchdogInterval: Yup.string().required("Required"),
  });

  return (
    <Modal
      show={openAddWatchdogModal}
      onHide={handleClose}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>Add Watchdog</Modal.Header>
      <Modal.Body>
        <Formik
          formikProps
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={async (values, { setValues }) => {
            const data = {
              actionType: values.actionType,
              warning: values.warning,
              warning1: values.warning1,
              warning2: values.warning2,
              service: values.service,
              unitType: values.unitType,
              amount: values.amount,
            };
            if (
              values.actionType === "SUSPEND" ||
              values.suspendInterval === true
            ) {
              if (values.suspendInterval === "monthly") {
                data.suspendInterval = 30;
              } else if (values.suspendInterval === "weekly") {
                data.suspendInterval = 7;
              } else if (values.suspendInterval === "daily") {
                data.suspendInterval = 1;
              }
            }
            if (values.watchdogInterval === "monthly") {
              data.watchdogInterval = 30;
            } else if (values.watchdogInterval === "weekly") {
              data.watchdogInterval = 7;
            } else if (values.suspendInterval === "daily") {
              data.watchdogInterval = 1;
            }
            await dispatch(
              createWatchdog({
                imsiList: selectedSims.map((sim) => sim.imsi),
                data: data,
              })
            )
              .then(() => {
                notyf.open({
                  type: "success",
                  message: "Watchdog created successfully",
                  duration: 5000,
                  dismissible: false,
                  ripple: true,
                  position: {
                    x: "center",
                    y: "top",
                  },
                });
              })
              .catch((error) => {
                notyf.open({
                  type: "danger",
                  message: error,
                  duration: 5000,
                  dismissible: false,
                  ripple: true,
                  position: {
                    x: "center",
                    y: "top",
                  },
                });
              })
              .finally(() => {
                clearSelectedRows();
                setValues(initialValues);
                handleClose();
              });
          }}
        >
          {({
            errors,
            handleBlur,
            setFieldTouched,
            handleChange,
            handleSubmit,
            touched,
            values,
            setValues,
            validateForm,
            setFieldValue,
          }) => {
            return (
              <AddWatchdogForm
                values={values}
                errors={errors}
                touched={touched}
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
                handleChange={handleChange}
                handleBlur={handleBlur}
                handleSubmit={handleSubmit}
                setValues={setValues}
                initialValues={initialValues}
                handleClose={handleClose}
                clearSelectedSims={clearSelectedRows}
              />
            );
          }}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default AddWatchdogModal;
